/* eslint-disable react/no-unescaped-entities */
import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Form = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box
        padding={{ xs: 3, sm: 6 }}
        width={"100%"}
        component={Card}
        borderRadius={2}
        boxShadow={0}
        marginBottom={4}
      >
        <Typography variant="h6">
          Question & support:{" "}
          <Typography
            className="inline"
            component={Link}
            href="mailto:team@awardtool.com"
            variant="h6"
          >
            team@awardtool.com
          </Typography>
        </Typography>
        <Typography variant="h6">
          Ads & partnership:{" "}
          <Typography
            className="inline"
            component={Link}
            href="mailto:partnership@awardtool.com"
            variant="h6"
          >
            partnership@awardtool.com
          </Typography>
        </Typography>
        <Typography variant="h6">
          API access & developer:{" "}
          <Typography
            className="inline"
            component={Link}
            href="mailto:partnership@awardtool.com"
            variant="h6"
          >
            partnership@awardtool.com
          </Typography>
        </Typography>
      </Box>
      <Box>
        <Typography color="text.secondary" align={"center"}>
          We'll get back to you in 1-2 business days.
        </Typography>
      </Box>
    </Box>
  );
};

export default Form;
